import apiService from './api'

const api = apiService.api

export const subscriptionService = {
  async getPlans() {
    const { data } = await api.get('/admin/subscriptions')
    return data
  },
  async getPlan(id: string) {
    const { data } = await api.get(`/admin/subscriptions/${id}`)
    return data
  },
  async createPlan(payload: any) {
    const { data } = await api.post('/admin/subscriptions', payload)
    return data
  },
  async updatePlan(id: string, payload: any) {
    const { data } = await api.patch(`/admin/subscriptions/${id}`, payload)
    return data
  },
  async togglePlan(id: string, isActive: boolean) {
    const { data } = await api.patch(`/admin/subscriptions/${id}`, { isActive })
    return data
  },
  async grantPremium(userId: number, planId: number, days: number) {
    const { data } = await api.post(`/admin/subscriptions/users/${userId}/grant-premium`, { planId, days })
    return data
  },
}
